import classNames from "classnames";
import { ReactNode } from "react";
import "./sidebar-section.scss";

export type SidebarSectionTitleVariant = "primary" | "profile";

export interface SidebarSectionProps {
  readonly title: string;
  readonly children?: ReactNode;
  readonly className?: string;
  readonly titleVariant?: SidebarSectionTitleVariant;
}

export default function SidebarSection({
  title,
  children,
  className,
  titleVariant = "primary",
}: SidebarSectionProps) {
  return (
    <section
      className={classNames("sidebar-section", className)}
      aria-labelledby={`sidebar-section-${title}`}
    >
      <div
        className={classNames(
          "sidebar-section__title-row",
          `sidebar-section__title-row--${titleVariant}`,
        )}
      >
        <h2
          id={`sidebar-section-${title}`}
          className="sidebar-section__title label-xsmall-medium"
        >
          {title}
        </h2>
      </div>
      {children ? <div className="sidebar-section__content">{children}</div> : null}
    </section>
  );
}
